import { useEffect, useState } from 'react';

/**
 * Hook per gestire lo stato e il comportamento comune dei modali
 * - Gestisce l'apertura/chiusura
 * - Gestisce il tasto Escape per chiudere
 * - Resetta lo stato quando il modal si apre
 */
export function useModal<T extends string = string>(
  isOpen: boolean,
  onClose: () => void,
  initialTab?: T
) {
  const [activeTab, setActiveTab] = useState<T | undefined>(initialTab);

  // Reset tab quando il modal si apre
  useEffect(() => {
    if (isOpen && initialTab) {
      setActiveTab(initialTab);
    }
  }, [isOpen, initialTab]);

  // Close on escape
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  return {
    activeTab,
    setActiveTab,
  };
}

